import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProjectPost } from '@frontend/unhideschool/shared/models/project/project-post.model';
import { Store, Select } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map, takeUntil } from 'rxjs/operators';
import { LoggedUserStateService } from '@frontend/unhideschool/app/core/services/legacy/logged-user.state';
import { CourseListSelectors } from '@frontend/unhideschool/app/shared-nxgs/course-list/course-list.selector';
import { animate, style, transition, trigger } from '@angular/animations';
import { UseTranslations } from '@frontend/unhideschool/app/utils/i18n/use-translation.decorator';
import { UNHHomeModel } from '@frontend/unhideschool/app/utils/i18n/locale/unh-home/models/unh-home.i18n.model';
import { ApplicationSelectors } from '@frontend/unhideschool/app/shared-nxgs/application/application.selectors';
import { ActivePromotion } from '@frontend/unhideschool/app/shared-nxgs/application/application.model';
import { NormalizedSubscriptionPlan } from '@frontend/unhideschool/app/modules/membership/models/membership-normalized-plan.model';

interface Translations {
  'unh-home': UNHHomeModel;
}

@Component({
  selector: 'unh-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0ms', style({ opacity: 0 })),
      ]),
    ]),
    trigger('enterAnimationLeave', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0ms', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
@UseTranslations({
  translatableComponents: ['unh-home'],
})
export class ProjectListComponent implements OnInit {
  pageTranslations: UNHHomeModel;
  translations: Promise<Translations>;

  private readonly onDestroy$ = new Subject();

  @Output() loadmore = new EventEmitter<any>();

  @Input() projects: ProjectPost[];
  @Input() isCourse: boolean = false;
  @Input() annualPrice: number;

  _ap: boolean;

  _activePromo;
  anualPlan: NormalizedSubscriptionPlan;

  @Input() set hasActivePromo(hasActivePromo: boolean) {
    this._ap = hasActivePromo;
  }

  get hasPromo(): boolean {
    return this._ap;
  }

  isMobile$: Observable<boolean>;

  @Select(CourseListSelectors.getIsNotFound())
  isNotFound$: Observable<boolean>;

  @Select(ApplicationSelectors.getActivePromotion())
  activePromo$: Observable<ActivePromotion>;

  constructor(
    private breakpointObserver: BreakpointObserver,
    public luss: LoggedUserStateService,
    private store: Store
  ) {}

  trackByFn(index, item) {
    return item.postid;
  }

  ngOnInit() {
    this.store
      .select(ApplicationSelectors.getActivePromotion())
      .subscribe((promo) => {
        if (promo && promo.active) {
          this._activePromo = promo.global;
        }
      });

    this.translations.then((translations) => {
      this.pageTranslations = translations['unh-home'];
    });
    this.isMobile$ = this.breakpointObserver.observe('(max-width: 978px)').pipe(
      takeUntil(this.onDestroy$),
      map((bo) => bo.matches)
    );

    this.store.select(ApplicationSelectors.getAnualPlan()).subscribe((plan) => {
      this.anualPlan = plan;
    });
  }

  onLoadmore() {
    this.loadmore.emit({});
  }

  toNumber(value: string): number {
    return Number(value);
  }
}
